// removed by extract-text-webpack-plugin
module.exports = {"checkbox":"checkbox","selected":"selected","icon":"icon","input-checkbox":"input-checkbox"};


//////////////////
// WEBPACK FOOTER
// ./src/application/component/checkbox/checkbox.style.sass
// module id = hTxh
// module chunks = 0